<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-text-input
        controlName="claimantId"
        placeholder="CL-00-0000-000"
        [maskConfig]="clIdMaskConfig"
      ></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-generic-input
        approvedNameCharacters
        controlName="firstName"
        [labelOverride]="FieldLabelConstants.ClaimantFirstName"
      ></app-generic-input>
    </div>
    <div class="col-6">
      <app-generic-input
        approvedNameCharacters
        controlName="lastName"
        [labelOverride]="FieldLabelConstants.ClaimantLastName"
      ></app-generic-input>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <app-text-input
        controlName="socialSecurityNumber"
        placeholder="SSN"
        [maskConfig]="ssnMaskConfig"
        (input)="onSSNChange()"
      ></app-text-input>
    </div>
    <div class="col-2 text-right">
      <h3 class="date-label">Date of Birth</h3>
    </div>
    <div class="col-2">
      <app-select-input
        [fetchData]="monthList"
        controlName="dateOfBirthMonth"
        (change)="dateValidator()"
      ></app-select-input>
      <mat-error
        class="date-error-message"
        *ngIf="form.get('dateOfBirthMonth').hasError('error')"
      >
        <ng-container>Month of birth requires Year</ng-container>
      </mat-error>
    </div>
    <div class="col-2">
      <app-select-input
        [fetchData]="dayList"
        controlName="dateOfBirthDay"
        (change)="dateValidator()"
      ></app-select-input>
      <mat-error class="date-error-message" *ngIf="form.get('dateOfBirthDay').hasError('error')">
        <ng-container>Day of birth requires Month and Year</ng-container>
      </mat-error>
    </div>
    <div class="col-2">
      <app-select-input
        [fetchData]="yearList"
        controlName="dateOfBirthYear"
        (change)="dateValidator()"
      ></app-select-input>
    </div>
  </div>
</form>
